module.exports = __webpack_public_path__ + "static/media/logo_trimex.19747c60.png";